import { useEffect, useState } from "react";
import Api from "../openapi";

export default function useChannels() {
  const [channelList, setChannelList] = useState<string[]>([]);

  useEffect(() => {
    const getChannels = async () => {
      try {
        const res = await Api.Partner.listPartnerChannels();
        setChannelList(res.data);
      } catch (error) {}
    };
    getChannels();
  }, []);
  return channelList;
}
